export default {
    entityKey: 'playbooks',
    titles: {
        singular: 'Playbook',
        plural: 'Playbooks'
    }
}